import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { solutionCycle } from '../../data/solutions';
import { fadeUp } from '../../utils/motion';
export function SolutionsCycle() {
  return <>
      <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-1583" data-mp="362q3vypjobri">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1584" data-mp="3a41n9mhts0r9">
          <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14" data-id="element-1585" data-mp="2w51xgbiktfti">
            <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-1586" data-mp="3145583pxy056">
              One connected approach
            </h2>
            <p className="lg:col-span-7 text-xl text-white/80 leading-relaxed lg:pt-3" data-id="element-1587" data-mp="2n66qgx7pk1p5">
              Across these settings, SyNeural’s work follows a common cycle.
            </p>
          </motion.div>

          <motion.ol {...fadeUp} aria-label="The SyNeural cycle" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/15 border border-white/15 rounded-lg overflow-hidden" data-id="element-1588" data-mp="lawe4jsiyqp1">
            {solutionCycle.map((step, index) => <li key={step} className="bg-navy-deep p-5 lg:p-6" data-id="element-1589" data-mp="tq1gi76m72cl" data-mpi={index}>
                <span className="block text-xs font-medium text-teal mb-2" data-id="element-1590" data-mp="18e60rflbflxh">{index + 1}</span>
                <span className="font-heading font-bold leading-snug" data-id="element-1591" data-mp="13fush9ao5jhd">{step}</span>
              </li>)}
          </motion.ol>

          <motion.div {...fadeUp} className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1592" data-mp="fqs9ny4atkla">
            <p className="lg:col-start-6 lg:col-span-7 text-lg text-white/75 leading-relaxed" data-id="element-1593" data-mp="atjqpvbbtciz">
              SKP helps people work with what is known and see how ideas relate.
              The Human Capability Framework defines how people’s learning,
              judgment, and growth can be assessed and developed. Noetivra makes
              both accessible in practice. Together, they support SyNeural’s wider vision:{' '}
              <span className="text-white font-semibold" data-id="element-1594" data-mp="2388h7j7ixtlj">
                building intelligence in the world—in research, in people, and
                in the institutions they create.
              </span>
            </p>
          </motion.div>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-28" data-id="element-1595" data-mp="2d432km34u2s0">
        <motion.div {...fadeUp} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1596" data-mp="2i47ncob2pjo1">
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight mb-6" data-id="element-1597" data-mp="1kia1qi1ecy7v">
            Build a solution with SyNeural
          </h2>
          <p className="text-xl text-ink-muted leading-relaxed mb-10" data-id="element-1598" data-mp="1ufoea6k792uw">
            The starting point is a specific question or challenge. We can
            design a research knowledge system, a human capability pilot, or an
            institutional workflow around what your organization needs to
            understand and improve.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1599" data-mp="16osr5mqouvtz">
            <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-navy text-white hover:bg-navy-light font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1600" data-mp="3k0n50kodkxse">
              Request a Demo
              <ArrowRight size={18} data-id="element-1601" data-mp="360ufgsol4nm0" />
            </a>
            <a href="/partnerships" className="inline-flex items-center justify-center border border-line text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1602" data-mp="360ccld7f3b54">
              Start a Partnership Conversation
            </a>
          </div>
        </motion.div>
      </section>
    </>;
}